import { ReactElement } from "react";
import { Box } from "@twilio-paste/core/box";
import { SkeletonLoader } from "@twilio-paste/core/skeleton-loader";
import { Stack } from "@twilio-paste/core/stack";
import { styled } from "@twilio-paste/core/styling-library";

const PreChatLoaderHorizontalContainer = styled(Box)`
  display: flex;
  gap: 1rem;
`;

const PreChatLoaderVerticalContainer = styled(PreChatLoaderHorizontalContainer)`
  flex-direction: column;
`;

const PreChatLoaderSkeletonContainer = styled(PreChatLoaderVerticalContainer)`
  gap: 0.5rem;
`;

const PreChatLoader = (): ReactElement => (
  <PreChatLoaderVerticalContainer as="div" paddingTop="space40">
    <SkeletonLoader height="150px" width="40%" />

    <Stack orientation="vertical" spacing="space20">
      <SkeletonLoader height="32px" width="80%" />
      <SkeletonLoader height="16px" width="60%" />
    </Stack>

    <PreChatLoaderHorizontalContainer as="div" width="100%">
      <PreChatLoaderSkeletonContainer as="span" width="50%">
        <SkeletonLoader height="54px" width="100%" />
        <SkeletonLoader height="54px" width="100%" />
        <SkeletonLoader height="54px" width="100%" />
        <SkeletonLoader height="54px" width="100%" />
      </PreChatLoaderSkeletonContainer>

      <PreChatLoaderSkeletonContainer as="span" width="50%">
        <SkeletonLoader height="54px" width="100%" />
        <SkeletonLoader height="54px" width="100%" />
        <SkeletonLoader height="54px" width="100%" />
        <SkeletonLoader height="54px" width="100%" />
      </PreChatLoaderSkeletonContainer>
    </PreChatLoaderHorizontalContainer>
  </PreChatLoaderVerticalContainer>
);

export default PreChatLoader;
